import { DateUtils } from "../utils/DateUtils";
import _ from "lodash";

export class DocumentNonReconnu {
    id?: number;
    import_metadata_id?: number;
    original_filename?: string;
    email_sender?: string;
    last_error?: string;
    files: Array<any> = [];
    created_at?: string;
    updated_at?: string;

    // Miroir de OvhAiEndpoints::TYPE_DOCUMENT
    static TYPE_DOCUMENT = {
        Facture: 1,
        BulletinDeSalaire: 2,
        AvisDeVirement: 3,
        AvisDePrelevement: 4,
        Autre: 5,
    };

    static TYPE_LABELS = {
        1: "Facture fournisseur",
        2: "Bulletin de salaire",
        3: "Avis de virement",
        4: "Avis de prélèvement",
    };

    constructor(data: any) {
        _.assign(this, _.omit(data, ["files"]));
        if (data.files) {
            this.files = data.files;
        }
    }

    get creation_date_str(): string {
        if (this.created_at) {
            return DateUtils.sqlToDateStr(this.created_at, "DD/MM/YYYY");
        }
        return "";
    }
}
